var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntroduction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1735552286095,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1496,
    width: 32,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 106.666667H112a5.333333 5.333333 0 0 0-5.333333 5.333333v800a5.333333 5.333333 0 0 0 5.333333 5.333333h800a5.333333 5.333333 0 0 0 5.333333-5.333333V112a5.333333 5.333333 0 0 0-5.333333-5.333333z m325.333333 736H186.666667a5.333333 5.333333 0 0 1-5.333334-5.333334V186.666667a5.333333 5.333333 0 0 1 5.333334-5.333334h650.666666a5.333333 5.333333 0 0 1 5.333334 5.333334v650.666666a5.333333 5.333333 0 0 1-5.333334 5.333334z",
    "p-id": 1497,
    fill: "#46766A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M261.333333 256m5.333334 0l490.666666 0q5.333333 0 5.333334 5.333333l0 85.333334q0 5.333333-5.333334 5.333333l-490.666666 0q-5.333333 0-5.333334-5.333333l0-85.333334q0-5.333333 5.333334-5.333333Z",
    "p-id": 1498,
    fill: "#46766A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M261.333333 426.666667m5.333334 0l202.666666 0q5.333333 0 5.333334 5.333333l0 330.666667q0 5.333333-5.333334 5.333333l-202.666666 0q-5.333333 0-5.333334-5.333333l0-330.666667q0-5.333333 5.333334-5.333333Z",
    "p-id": 1499,
    fill: "#46766A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M549.333333 634.666667m5.333334 0l202.666666 0q5.333333 0 5.333334 5.333333l0 122.666667q0 5.333333-5.333334 5.333333l-202.666666 0q-5.333333 0-5.333334-5.333333l0-122.666667q0-5.333333 5.333334-5.333333Z",
    "p-id": 1500,
    fill: "#46766A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M549.333333 426.666667m5.333334 0l202.666666 0q5.333333 0 5.333334 5.333333l0 122.666667q0 5.333333-5.333334 5.333333l-202.666666 0q-5.333333 0-5.333334-5.333333l0-122.666667q0-5.333333 5.333334-5.333333Z",
    "p-id": 1501,
    fill: "#46766A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroduction);
export default __webpack_public_path__ + "static/media/introduction.1360beb268c520f9629a4fd2e9170581.svg";
export { ForwardRef as ReactComponent };